<template>
  <IAITooltip :side-offset="22" :show="!!tooltipContent">
    <template #trigger>
      <IAICard
        class="card"
        :class="{
          [`border-${borderType}`]: !!borderType,
          [`bg-${bgType}`]: !!bgType,
        }"
      >
        <slot name="tag"></slot>

        <div class="w-full">
          <div class="flex justify-between">
            <slot name="upper-left"></slot>

            <slot name="upper-right"></slot>
          </div>

          <slot name="content"></slot>

          <slot name="middle-part"></slot>
        </div>

        <div class="cta-section w-full">
          <slot name="above-cta"></slot>

          <IAIButton
            class="flex h-9 w-full cursor-pointer justify-center font-sans"
            :label="ctaText"
            :is-loading="isCtaLoading"
            :disabled="isCtaDisabled"
            @click="emits('onCtaClicked')"
          />
        </div>
      </IAICard>
    </template>

    <template #content>
      <div>
        {{ tooltipContent }}
      </div>
    </template>
  </IAITooltip>
</template>

<script setup lang="ts">
import { IAICard, IAIButton, IAITooltip } from "@/core-ui-vue";
import { t } from "@/locales/vue";
import { PropType } from "vue";

type CardBorderType = "primary" | "secondary";
type BgType = "primary" | "secondary";

defineProps({
  ctaText: {
    type: String,
    default: t("pages.credit-packages.buy-now"),
  },
  isCtaLoading: {
    type: Boolean,
    default: false,
  },
  isCtaDisabled: {
    type: Boolean,
    default: false,
  },
  tooltipContent: {
    type: String,
  },
  borderType: {
    type: String as PropType<CardBorderType>,
    default: null,
  },
  bgType: {
    type: String as PropType<BgType>,
    default: null,
  },
});

const emits = defineEmits(["onCtaClicked"]);
</script>

<style scoped lang="scss">
.card {
  padding: 2.5rem 1.875rem;
  flex: 1;
  max-width: 22rem;
  width: 22rem;
  height: 18.6875rem;
  border-radius: 12px;
  color: black;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  align-items: center;
}

.cta-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.package-card-border {
  @apply border-4 border-blueish-blue;
}

.border-primary {
  @apply border-4 border-blueish-blue;
}

.border-secondary {
  @apply border-1 border-theme-3;
}
.bg-secondary {
  @apply bg-light-pink;
}
</style>
